import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary caught an error]:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.iconBox}>⚠️</div>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.text}>
              An unexpected error occurred while loading this page. Please try refreshing or return to the home page.
            </p>
            <div style={styles.btnRow}>
              <button style={styles.primaryBtn} onClick={this.handleReload}>
                Refresh Page
              </button>
              <button style={styles.secondaryBtn} onClick={this.handleGoHome}>
                Return Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F8FAFC",
    padding: "20px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    maxWidth: "480px",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "36px 30px",
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    border: "1px solid #E2E8F0",
  },
  iconBox: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#0F172A",
    margin: "0 0 10px",
  },
  text: {
    fontSize: "14px",
    color: "#64748B",
    lineHeight: "1.5",
    margin: "0 0 24px",
  },
  btnRow: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  primaryBtn: {
    padding: "10px 20px",
    backgroundColor: "#F5821F",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  secondaryBtn: {
    padding: "10px 20px",
    backgroundColor: "#F1F5F9",
    color: "#334155",
    border: "1px solid #CBD5E1",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default ErrorBoundary;
